import PropTypes from "prop-types";
import React from "react";
import {useTranslation} from "react-i18next";

import {ReactComponent as SearchSvg} from "assets/icons/search.svg";
import Icon from "layout/atoms/Icon";
import {Error, Label, Wrapper} from "./styles";

const InputText = ({
  type = "text",
  name,
  label,
  placeholder = "",
  defaultValue = "",
  register,
  validation,
  disabled,
  errors,
  autoComplete = "on",
  search = false,
  value,
  onChange,
}) => {
  const { t } = useTranslation();
  const inputProps = {
    type,
    name,
    placeholder,
    autoComplete,
    disabled,
  };

  const controlledProps = register
    ? { ...register(name, validation), defaultValue }
    : { value, onChange };

  const displayErrors = () => {
    const ruleValue = (rule) =>
      rule !== null && typeof rule === "object" ? rule.value : rule;
    const message = {
      required: t("formErrors.required"),
      minLength: t("formErrors.minLength", { n: ruleValue(validation.minLength) }),
      maxLength: t("formErrors.maxLength", { n: ruleValue(validation.maxLength) }),
      default: errors.message,
    };

    return <Error>{errors.message || message[errors.type] || message["default"]}</Error>;
  };

  return (
    <Wrapper disabled={disabled} hasErrors={errors} search={search}>
      {label && <Label htmlFor={name}>{label}</Label>}
      {search && (
        <span>
          <Icon src={SearchSvg} />
        </span>
      )}
      {type === "textarea" ? (
        <textarea {...inputProps} {...controlledProps} />
      ) : (
        <input {...inputProps} {...controlledProps} />
      )}
      {errors && displayErrors()}
    </Wrapper>
  );
};

InputText.propTypes = {
  type: PropTypes.oneOf([
    "email",
    "text",
    "number",
    "tel",
    "password",
    "textarea",
  ]),
  name: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  defaultValue: PropTypes.string,
  search: PropTypes.bool,
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default InputText;
